export default {_name:'card.simple.small',module:'Field',view:'Element/Card/Small',webOptions:{sm:6,xs:12,ms:12},mobileOptions:{ms:6}}